import arrowImg from "../assets/images/backarrow.png";
import homestyles from "../assets/styles/home.module.css"
function Backarrow({setCurrentTab}) {

  return (
    <div className={`backBtn`} onClick={() => setCurrentTab("home")}>
        <img alt="back" className={homestyles.imgBtn} src={arrowImg}/>
    </div>
  );
}
export default Backarrow;